import { render, staticRenderFns } from "./s-list.vue?vue&type=template&id=f183e6b6&"
import script from "./s-list.vue?vue&type=script&lang=js&"
export * from "./s-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports